/* CERRAR VENTANA EMERGENTE | INICIO */
function cerrar_ventana_emergente(){
    const contenedor_ventana_emergente = document.getElementById("id-contenedor-ventana-emergente");
    if (contenedor_ventana_emergente) {
        contenedor_ventana_emergente.style.display = "none";
        contenedor_ventana_emergente.style.pointerEvents = "none";
    }
}
/* CERRAR VENTANA EMERGENTE | FINAL */



/* COPIAR CUPÓN | INICIO */
function copiar_cupon_ventana_emergente(){
    const cupon = document.getElementById("cupon_activo");
    if (cupon) {
        navigator.clipboard.writeText(cupon.textContent);
    }
}
/* COPIAR CUPÓN | FINAL */



/* LLUVIA DE SVGS DINÁMICA Y ALEATORIA | INICIO */
(function () {
    const contenedorLluvia = document.getElementById("id-lluvia-svg-ventana-emergente");

    if (!contenedorLluvia) return;

    const svgSrc = contenedorLluvia.dataset.svgSrc;
    if (!svgSrc) return;

    const velocidadUsuario = parseFloat(contenedorLluvia.dataset.velocidad) || 5;
    const cantidadElementos = parseInt(contenedorLluvia.dataset.cantidad, 10) || 18;
    const tamanoBase = parseFloat(contenedorLluvia.dataset.tamano) || 32;

    const duracionBase = Math.max(1.5, 12 - (velocidadUsuario * 1.05));

    function valorAleatorio(min, max) {
        return Math.random() * (max - min) + min;
    }

    function crearGotaSvg() {
        const gota = document.createElement("img");
        gota.src = svgSrc;
        gota.setAttribute("aria-hidden", "true");
        gota.draggable = false;

        const posicionHorizontal = valorAleatorio(0, 92);
        const tamanoAleatorio = tamanoBase * valorAleatorio(0.7, 1.3);
        const duracionAleatoria = duracionBase * valorAleatorio(0.75, 1.3);
        const retrasoAleatorio = valorAleatorio(0, duracionBase);
        const giroAleatorio = valorAleatorio(-15, 15);

        gota.style.left = posicionHorizontal + "%";
        gota.style.width = tamanoAleatorio + "px";
        gota.style.animationDuration = duracionAleatoria + "s";
        gota.style.animationDelay = "-" + retrasoAleatorio + "s";
        gota.style.transform = "rotate(" + giroAleatorio + "deg)";

        return gota;
    }

    function iniciarLluvia() {
        contenedorLluvia.innerHTML = "";
        for (let i = 0; i < cantidadElementos; i++) {
            contenedorLluvia.appendChild(crearGotaSvg());
        }
    }

    iniciarLluvia();

    setInterval(() => {
        const gotaVieja = contenedorLluvia.children[0];
        if (gotaVieja) {
            contenedorLluvia.removeChild(gotaVieja);
            contenedorLluvia.appendChild(crearGotaSvg());
        }
    }, (duracionBase * 1000) / cantidadElementos);
})();


document.addEventListener("keydown", (e) =>{
    if(e.key === "Escape"){
        cerrar_ventana_emergente();
    }
})
/* LLUVIA DE SVGS DINÁMICA Y ALEATORIA | FINAL */